import {
  IAccessTokenAuthValidationAPIPayload,
  IAccessTokenAuthValidationAPIResponse,
  IAllowUserAPIResponse,
  IAllowUserPayload,
  ISendOTP,
  ISendOTPAPIResponse,
  ISsoAuthAPIResponse,
  ISsoAuthValidationPayload,
  IUserIdentity,
  TJoinInterviewPayload,
} from "@/types/auth.types";
import { IGetServerTimeAPIResponse } from "@/types/serverTime.types";
import { HTTP_METHODS, HTTP_STATUS_CODES } from "@/constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";

export const sendOTPAPI = (payload: ISendOTP) =>
  sendRequestToInterviewWithCredential<ISendOTPAPIResponse>({
    method: HTTP_METHODS.POST,
    url: `/send_otp/`,
    data: payload,
  });

export const getServerTimeAPI = () =>
  sendRequestToInterviewWithCredential<IGetServerTimeAPIResponse>({
    method: HTTP_METHODS.GET,
    url: `/get_server_time/`,
  });

export const joinInterviewAPI = (
  interviewSlug: string,
  payload: TJoinInterviewPayload,
) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/join/`,
    data: payload,
  });

export const startInterviewAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IUserIdentity>({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/start/`,
  });

export const getUserStatusAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IUserIdentity>(
    {
      method: HTTP_METHODS.GET,
      url: `/interviews/${interviewSlug}/status/`,
    },
    [HTTP_STATUS_CODES.UNAUTHORIZED, HTTP_STATUS_CODES.FORBIDDEN],
  );

export const leaveUserAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/leave/`,
  });

export const leaveAllUserAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/leave_all/`,
  });

export const allowUserAPI = (
  interviewSlug: string,
  payload: IAllowUserPayload,
) =>
  sendRequestToInterviewWithCredential<IAllowUserAPIResponse>({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/allow/`,
    data: payload,
  });

export const ssoAuthValidation = (payload: ISsoAuthValidationPayload) =>
  sendRequestToInterviewWithCredential<ISsoAuthAPIResponse>({
    method: HTTP_METHODS.POST,
    url: "/integrations/validate_redirection_url/",
    data: payload,
  });

export const accessTokenValidationAPI = (
  payload: IAccessTokenAuthValidationAPIPayload,
) =>
  sendRequestToInterviewWithCredential<IAccessTokenAuthValidationAPIResponse>({
    method: HTTP_METHODS.POST,
    url: "/auth/validate_token/",
    data: payload,
  });
